import React from 'react'
import { Grid, TextField, Button } from '@mui/material'

const STHomePageRows = ({
    fields,
    handleDeleteInput
}) => {

    return (
        <>
        { fields?.map((item, index) => (
            <Grid key={index} container direction="row" spacing={2}>        
                <Grid item xs={8} sm={6} md={6}>
                    <TextField
                        fullWidth
                        margin="dense"
                        label="PID"
                        name="PId"
                        value={item.PId}
                        disabled={true}
                    />
                </Grid>
                <Grid item xs={4} sm={6} md={6}>
                    {/* <Grid container direction="row" spacing={1} display={'flex'} justifyContent={'flex-start'}>
                        <Grid item > */}
                            <Button
                                onClick={() => handleDeleteInput(index)}
                                variant="contained"
                                size="small"
                                color="error"
                                sx={{mt:2}}
                            >Delete
                            </Button>
                        {/* </Grid>
                    </Grid>  */}
                </Grid>         
            </Grid>
        ))}
        </>
    )
}

export default STHomePageRows